import { useDispatch } from "react-redux";
import { Mixpanel } from "utils/mixpanel";
import { dispatchUpdateMiniPlayer } from "modules/MiniPlayer/actions";
import { dispatchUpdateAccount } from "modules/Account/actions";
import { dispatchLogin } from "modules/Config/actions";
import { PAGE_ORIGIN_UNKNOWN } from "utils/nameVariables";

const useLogout = () => {
  const dispatch = useDispatch();
  const logoutFunc = () => {
    localStorage.clear();
    Mixpanel.reset();
    dispatch(
      dispatchUpdateMiniPlayer({
        playing: false,
        url: null,
        indexOfTrack: 0,
        dataTrack: null,
        isWebPlayer: false,
        collapsed: true,
        slug: null,
        composerImage: null,
        composerName: null,
        composerSlug: null,
        composerId: null,
        playlist: null,
        playlistId: null,
        pageOrigin: PAGE_ORIGIN_UNKNOWN,
        mediaId: null,
        mediaProps: null,
      })
    );
    dispatch(dispatchLogin(false));
    dispatch(dispatchUpdateAccount(null));
  };

  return logoutFunc;
};

export default useLogout;
